import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, sumBy, orderBy, isEmpty, flatMap, uniq } from 'lodash-es';
// Models
import { InventoryEntities, InventoryModel } from 'client/data/models/inventory';
// Utils
import { getSortedOptionDescriptions } from 'site-modules/shared/utils/get-sorted-option-descriptions';
import { isPartnerDealer } from 'site-modules/shared/utils/dealer-details-utils';
import { hideOptions } from 'site-modules/shared/utils/hide-options';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { getFeaturesByCategories } from 'client/site-modules/shared/utils/inventory/features-and-specs';
import { getOptionPrice } from 'client/site-modules/shared/utils/inventory/get-option-price';
// Constants
import { FEATURES } from 'client/site-modules/shared/constants/inventory/features-and-specs';
// Components
import { FeaturesModalView } from 'site-modules/inventory/components/features-modal-view/features-modal-view';

import './features-modal.scss';

export function FeaturesModalUI({
  vinData = {},
  isModalOpen = false,
  toggleModal = null,
  optionPrices = null,
  isMobile = false,
  defaultDisplay = FEATURES,
}) {
  const options = getSortedOptionDescriptions(vinData);
  const optionsLength = options.length;
  const featuresByCategories = getFeaturesByCategories(vinData);
  const defaultFeatures = flatMap(featuresByCategories, features => features.map(feature => feature.optionText));
  const isEmptyFeatures = isEmpty(featuresByCategories);
  const featuresToDisplay = uniq([...options, ...defaultFeatures]).sort();
  const isPartnerListing = isPartnerDealer(vinData);

  const upgrades = get(vinData, 'vehicleInfo.partsInfo.options', []);
  const updatedOptions = upgrades.map(upgrade => ({
    ...upgrade,
    price: getOptionPrice(get(optionPrices, upgrade.id, {})),
  }));
  const packageValue = sumBy(updatedOptions, 'price');
  const orderedOptions = orderBy(updatedOptions, ['price'], ['desc']);

  const showInstalledUpgrades = isPartnerListing && !hideOptions(vinData) && !!upgrades.length;
  const hideFeatures = !optionsLength && isEmptyFeatures;
  const showToggleBtns = !hideFeatures && showInstalledUpgrades;

  return (
    <FeaturesModalView
      vinData={vinData}
      isModalOpen={isModalOpen}
      toggleModal={toggleModal}
      isMobile={isMobile}
      defaultDisplay={defaultDisplay}
      packageValue={packageValue}
      orderedOptions={orderedOptions}
      featuresToDisplay={featuresToDisplay}
      showToggleBtns={showToggleBtns}
      hideFeatures={hideFeatures}
    />
  );
}

FeaturesModalUI.propTypes = {
  vinData: InventoryEntities.InventoryVin,
  isModalOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  optionPrices: PropTypes.objectOf(
    PropTypes.shape({
      baseMSRP: PropTypes.number,
    })
  ),
  isMobile: PropTypes.bool,
  defaultDisplay: PropTypes.string,
};

export const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const stateToPropsConfig = {
  optionPrices: bindToPath(({ vinData: { vin } }) => `optionPrices["${vin}"]`, InventoryModel),
};

export const FeaturesModal = connect(mapStateToProps)(connectToModel(FeaturesModalUI, stateToPropsConfig));
